module.exports = __webpack_public_path__ + "static/media/expo-4-2-2.7ec8d031.png";